import { Accordion } from '@/components/ui/accordion';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Anstellungsverhaeltnis } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Anstellungsverhaeltnis';
import { Arbeitsbereiche } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Arbeitsbereiche';
import { Bezahlung } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung';
import { Kontakt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Kontakt';
import { Persoenliches } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Persoenliches';

import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Zusammenfassung() {
  return (
    <div className="flex flex-col items-start lg:flex-row gap-8 p-4 md:pt-0">
      <div className="md:w-96 w-full">
        <Card className="p-5 bg-neutrals-100 rounded-3xl shadow-lg">
          <div className="flex flex-col gap-3">
            <Avatar className="size-16">
              <AvatarFallback>
                <FontAwesomeIcon icon={faUser} className="size-5" />
              </AvatarFallback>
            </Avatar>
            <Persoenliches />
            <Kontakt />
            <Separator />
            <Arbeitsbereiche />
          </div>
        </Card>
      </div>
      <div className="grow">
        <Accordion
          type="multiple"
          defaultValue={['anstellungsverhaeltnis', 'bezahlung']}>
          <Anstellungsverhaeltnis />
          <Bezahlung />
        </Accordion>
      </div>
    </div>
  );
}
